import * as React from "react";
import { defaultTablePageSize } from "~/common/components/consts";
import { ContextScrollTop } from "~/common/layout/PageContentWrapper";

type Props = {
  page: number;
  pageSize?: number;
  pages: Array<number>;
  data: Array<any>;
  PageButtonComponent: any;
  onPageChange: (number) => void;
};

const defaultButton = (props) => <button {...props}>{props.children}</button>;

class PaginateSimple extends React.Component<Props> {
  static defaultProps = {
    page: 0,
    pages: [1],
    data: [],
  };

  static contextType = ContextScrollTop;
  context: React.ContextType<typeof ContextScrollTop>;

  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);
  }

  changePage(changedActivePage) {
    const { page, onPageChange } = this.props;

    if (page === changedActivePage) {
      return;
    }
    if (this.context) this.context();
    onPageChange(changedActivePage);
  }

  render() {
    const { PageButtonComponent = defaultButton, page, data } = this.props;
    const disableNext = data.length < (this.props.pageSize || defaultTablePageSize);

    return (
      <div className="-pagination">
        <div className="-previous">
          <PageButtonComponent
            className="-btn"
            onClick={() => {
              if (page === 0) return;
              this.changePage(page - 1);
            }}
            disabled={page === 0}
          >
            Previous
          </PageButtonComponent>
        </div>

        <div className="-center">
          <span className="-pageInfo">Page {page + 1} </span>
        </div>

        <div className="-next">
          <PageButtonComponent
            className="-btn"
            onClick={() => {
              if (disableNext) return;
              this.changePage(page + 1);
            }}
            disabled={disableNext}
          >
            Next
          </PageButtonComponent>
        </div>
      </div>
    );
  }
}

export default PaginateSimple as any;
